import { styles } from './Separator.style';

export const Separator = ({ background, style: customStyle }) => {
  const style = styles({ background, customStyle });
  return <div style={style} className="separator"></div>;
};
